import axios from 'axios'
export const BASE_URL_ONLINESERVICE_OLD = 'http://124.71.124.143:12345';
export const BASE_URL_ONLINESERVICE = 'http://124.71.124.143:9000';
const request = axios.create({
    // baseURL: 'http://localhost:8080',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
    baseURL: BASE_URL_ONLINESERVICE,
    timeout: 120000
})
export const source=axios.CancelToken.source();
// request 拦截器
request.interceptors.request.use(config => {
    // config.headers['token'] = sessionStorage.getItem("token");
    // console.log("token: "+config.headers['token'])
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)
export default request

